import { ChangeEvent, FC } from 'react';
import { Column, Table } from '@tanstack/react-table';
import { Select } from '@chakra-ui/react';

const BooleanColumnFilter: FC<{ column: Column<any, any>; table: Table<any> }> = ({ column, table }) => {
    const preFilteredRows = table.getPreFilteredRowModel().rows;
    const type = preFilteredRows[0] ? typeof preFilteredRows[0].getValue(column.id) : 'boolean';
    const isStringCheck = ['string', 'number'].includes(type);
    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        column.setFilterValue(e.target.value || '');
    };

    return (
        <Select size="sm" value={(column.getFilterValue() as string) || ''} onChange={handleChange}>
            <option value=""> ALL </option>
            <option value={isStringCheck ? '1' : 'true'}>Yes</option>
            <option value={isStringCheck ? '0' : 'false'}>No</option>
        </Select>
    );
};

export default BooleanColumnFilter;
